var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _c("div", { staticClass: "index_header" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "top" }, [
          _c("img", {
            staticClass: "menu_lc",
            attrs: { src: "/assets/web/assets/menu_lc.png" },
            on: {
              click: function ($event) {
                return _vm.menuClick()
              },
            },
          }),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "right" }, [
            _c("img", {
              staticClass: "psl_click",
              attrs: { src: "/assets/web/assets/psl_icon.png" },
              on: {
                click: function ($event) {
                  return _vm.jump("user")
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "header_search flex-start align-center" }, [
          _c("div", {
            staticClass: "header_searchm",
            on: {
              click: function ($event) {
                return _vm.jump("search")
              },
            },
          }),
          _vm._v(" "),
          _c("img", { attrs: { src: "/assets/web/assets/index_search.png" } }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.search.keyword,
                expression: "search.keyword",
              },
            ],
            attrs: { type: "text", placeholder: "想找点什么？" },
            domProps: { value: _vm.search.keyword },
            on: {
              keyup: _vm.searchGoods,
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.search, "keyword", $event.target.value)
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _vm.isMenu
        ? _c(
            "div",
            {
              staticClass: "menu_mask",
              on: {
                click: function ($event) {
                  return _vm.menuClick()
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "in" },
                [
                  _c("router-link", { attrs: { to: "/user/sell" } }, [
                    _c("div", { staticClass: "icon" }, [
                      _c("img", {
                        attrs: { src: "/assets/web/assets/maimai.png" },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v("卖号")]),
                  ]),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "index_banner" },
      [
        _c(
          "el-carousel",
          { ref: "slideCarousel" },
          _vm._l(_vm.bannerList, function (item, index) {
            return _c(
              "el-carousel-item",
              { key: index },
              [
                _c("router-link", { attrs: { to: item.url } }, [
                  _c("img", { attrs: { src: item.litpic } }),
                ]),
              ],
              1
            )
          }),
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { "background-color": "#ffffff" } },
      [
        _c("router-link", { attrs: { to: "/baopei" } }, [
          _c("div", { staticClass: "info_swiper" }, [
            _c("div", { staticClass: "in" }, [
              _c(
                "p",
                _vm._l(_vm.infoList, function (item, index) {
                  return _c("span", { key: index }, [_vm._v(_vm._s(item))])
                }),
                0
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "index_navline" },
          _vm._l(_vm.navList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "nav",
                on: {
                  click: function ($event) {
                    return _vm.jump(item.href)
                  },
                },
              },
              [
                item.type
                  ? _c(
                      "span",
                      {
                        staticClass: "tips",
                        class: item.type == "new" ? "n" : "",
                      },
                      [_vm._v(_vm._s(_vm._f("typeTips")(item.type)))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "icon" }, [
                  _c("img", { attrs: { src: item.icon } }),
                ]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(item.name))]),
              ]
            )
          }),
          0
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "index_bacc" }, [
      _c("div", { staticClass: "left" }, [
        _c(
          "div",
          {
            staticClass: "l_type",
            on: {
              click: function ($event) {
                return _vm.jump("list")
              },
            },
          },
          [
            _c("span", { staticClass: "tips" }, [_vm._v("热门")]),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("p", { staticClass: "t" }, [_vm._v("我要买号")]),
            _vm._v(" "),
            _c("p", { staticClass: "i", staticStyle: { color: "#d3a675" } }, [
              _vm._v("梦幻西游手游"),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c(
          "a",
          {
            staticClass: "bacc2_btn",
            on: {
              click: function ($event) {
                return _vm.jump("recycling")
              },
            },
          },
          [
            _c("img", {
              attrs: { src: "/assets/web/assets/bacc2_icon1.png?v=310" },
            }),
            _vm._v(" "),
            _c("span", [_vm._v("高价回收")]),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "bacc2_btn",
            on: {
              click: function ($event) {
                return _vm.jump("zhaohao")
              },
            },
          },
          [
            _c("img", {
              attrs: { src: "/assets/web/assets/bacc2_icon2.png?v=310" },
            }),
            _vm._v(" "),
            _c("span", [_vm._v("免费找号")]),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "bacc2_btn",
            on: {
              click: function ($event) {
                return _vm.jump(
                  "https://www.douyin.com/user/MS4wLjABAAAAm2KNhWmW2gDXUv9jgI71KjTVcsJsgqCbofO5-wKTt_Y?from_tab_name=main"
                )
              },
            },
          },
          [
            _c("img", {
              attrs: { src: "/assets/web/assets/bacc2_icon3.png?v=310" },
            }),
            _vm._v(" "),
            _c("span", [_vm._v("直播估价")]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c(
          "a",
          {
            staticClass: "bacc_btn",
            on: {
              click: function ($event) {
                return _vm.jump("fenqi")
              },
            },
          },
          [
            _c("img", { attrs: { src: "/assets/web/assets/bacc_icon1.png" } }),
            _vm._v(" "),
            _c("span", [_vm._v("分期购号")]),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "bacc_btn",
            on: {
              click: function ($event) {
                return _vm.jump("zhongjie")
              },
            },
          },
          [
            _c("img", { attrs: { src: "/assets/web/assets/bacc_icon2.png" } }),
            _vm._v(" "),
            _c("span", [_vm._v("约定交易")]),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "bacc_btn",
            on: {
              click: function ($event) {
                return _vm.jump("baopei")
              },
            },
          },
          [
            _c("img", { attrs: { src: "/assets/web/assets/bacc_icon3.png" } }),
            _vm._v(" "),
            _c("span", [_vm._v("找回包赔")]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "index_recent" }, [
      _c("div", { staticClass: "recent_line" }, [
        _c("img", {
          staticClass: "icon",
          attrs: { src: "/assets/web/assets/recent_icon1b.png" },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "r" },
          [
            _c("p", { staticClass: "f13 col333" }, [
              _vm._v(
                _vm._s(_vm.web_config.jjy3 ? _vm.web_config.jjy3[0] : "-")
              ),
            ]),
            _vm._v(" "),
            _c(
              "swiper",
              { attrs: { options: _vm.recentOne } },
              _vm._l(_vm.web_config.jjy, function (item, index) {
                return _c(
                  "swiper-slide",
                  { key: index, staticClass: "swiper-slide" },
                  [_c("span", [_vm._v(_vm._s(item))])]
                )
              }),
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "recent_line" }, [
        _c("img", {
          staticClass: "icon",
          attrs: { src: "/assets/web/assets/recent_icon2b.png" },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "r" },
          [
            _c("p", [
              _vm._v(_vm._s(_vm.web_config.jjy4 ? _vm.web_config.jjy4[0] : "")),
            ]),
            _vm._v(" "),
            _c(
              "swiper",
              { attrs: { options: _vm.recentTwo } },
              _vm._l(_vm.web_config.jjy2, function (item, index) {
                return _c(
                  "swiper-slide",
                  { key: index, staticClass: "swiper-slide" },
                  [_c("span", [_vm._v(_vm._s(item))])]
                )
              }),
              1
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "index_gamebox" }, [
      _c(
        "div",
        { staticClass: "top" },
        _vm._l(_vm.gameClass, function (item, index) {
          return _c(
            "span",
            {
              key: index,
              staticClass: "btn",
              class: _vm.gameOn == index ? "on" : "",
              on: {
                click: function ($event) {
                  return _vm.gameClick(index)
                },
              },
            },
            [_vm._v(_vm._s(item.title))]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "search" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.gameKeyword,
              expression: "gameKeyword",
            },
          ],
          attrs: { type: "text", placeholder: "请输入游戏名" },
          domProps: { value: _vm.gameKeyword },
          on: {
            keyup: _vm.searchGame,
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.gameKeyword = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c("button", {
          staticClass: "searchbtn",
          on: { click: _vm.searchGame },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "swiper",
            { attrs: { options: _vm.gameSwiper } },
            _vm._l(_vm.gameList, function (item, index) {
              return _c(
                "swiper-slide",
                { key: index, staticClass: "swiper-slide game_type" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/list?gameid=" + item.id } },
                    [
                      _c("div", { staticClass: "img" }, [
                        _c("img", { attrs: { src: item.litpic } }),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "title" }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                    ]
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "index_checkline" }, [
      _c("div", { staticClass: "check_line" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.checkServerInfo,
              expression: "checkServerInfo",
            },
          ],
          attrs: { type: "text", placeholder: "请输入客服微信号" },
          domProps: { value: _vm.checkServerInfo },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.checkServerInfo = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c("button", { on: { click: _vm.checkServer } }, [
          _vm._v("验收客服微信"),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "check_line" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.checkBankIdInfo,
              expression: "checkBankIdInfo",
            },
          ],
          attrs: { type: "text", placeholder: "请输入收款账号" },
          domProps: { value: _vm.checkBankIdInfo },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.checkBankIdInfo = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c("button", { on: { click: _vm.checkBankId } }, [
          _vm._v("验收收款账号"),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "index_newsbox" }, [
      _c(
        "div",
        { staticClass: "top" },
        [
          _c("span", { staticClass: "t" }, [_vm._v("资讯公告")]),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "more flex-start align-center",
              attrs: { to: "/news" },
            },
            [
              _c("span", [_vm._v("更多")]),
              _vm._v(" \n          "),
              _c("img", {
                attrs: { src: "/assets/web/assets/icon2.png", alt: "" },
              }),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container" },
        _vm._l(_vm.newsList, function (item, index) {
          return _c(
            "a",
            {
              key: index,
              staticClass: "type",
              on: {
                click: function ($event) {
                  return _vm.jump(item.href)
                },
              },
            },
            [
              _c("span", { staticClass: "c" }, [
                _vm._v("[" + _vm._s(item.category.name) + "]"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "t" }, [_vm._v(_vm._s(item.name))]),
              _vm._v(" "),
              _c("span", { staticClass: "d" }, [
                _vm._v(_vm._s(item.createdAt)),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "index_bottomline flex-center align-center" },
      [
        _c("router-link", { staticClass: "a", attrs: { to: "/aciden" } }, [
          _c("img", { attrs: { src: "/assets/web/assets/ib_icon1.png" } }),
          _vm._v(" "),
          _c("span", [_vm._v("真假客服鉴定")]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "a",
            on: {
              click: function ($event) {
                return _vm.showService()
              },
            },
          },
          [
            _c("img", { attrs: { src: "/assets/web/assets/ib_icon2.png" } }),
            _vm._v(" "),
            _c("span", [_vm._v("在线咨询")]),
          ]
        ),
        _vm._v(" "),
        _c("router-link", { staticClass: "a", attrs: { to: "fenqi" } }, [
          _c("img", { attrs: { src: "/assets/web/assets/ib_icon3.png" } }),
          _vm._v(" "),
          _c("span", [_vm._v("分期计算器")]),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _c("div", { staticClass: "index_footer" }, [
      _c("div", { staticClass: "navline" }, [
        _c("ul", [
          _c(
            "li",
            [
              _c("router-link", { attrs: { to: "jianjie" } }, [
                _vm._v("关于弥亚猪"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("router-link", { attrs: { to: "stm5" } }, [
                _vm._v("扫黑除恶"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                on: {
                  click: function ($event) {
                    return _vm.showService()
                  },
                },
              },
              [_vm._v("意见反馈")]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _vm._m(4),
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "tcbg",
      style: { display: _vm.service ? "block" : "none" },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "tckf",
        staticStyle: {
          background: "url(/assets/web/assets/icon16.png) no-repeat center top",
          "background-size": "100% auto",
        },
        style: { display: _vm.service ? "block" : "none" },
        attrs: { onselectstart: "return false;" },
      },
      [
        _c(
          "div",
          { staticClass: "tckfbox" },
          [
            _vm._m(5),
            _vm._v(" "),
            _c("span", {
              staticClass: "kfclose",
              on: {
                click: function ($event) {
                  return _vm.showService()
                },
              },
            }),
            _vm._v(" "),
            _c("kf"),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "logo",
        staticStyle: { height: "0.63rem", "text-align": "center" },
      },
      [
        _c("img", {
          staticStyle: { height: "100%" },
          attrs: { src: "/assets/web/assets/logob.png" },
        }),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("img", { attrs: { src: "/assets/web/assets/wymh_icon.png" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "index_telline", attrs: { href: "tel:18989545463" } },
      [
        _c("img", { attrs: { src: "/assets/web/assets/kfrx_icon.png" } }),
        _vm._v(" "),
        _c("span", [_vm._v("客服热线："), _c("i", [_vm._v("18989545463")])]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("p", [_vm._v("弥亚猪24个小时为您提供安全快捷的服务")]),
      _vm._v(" "),
      _c("p", [
        _c(
          "a",
          { attrs: { href: "https://beian.miit.gov.cn", target: "_blank" } },
          [_vm._v("浙ICP备18024664号")]
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("诸暨市弥亚信息技术有限公司")]),
      _vm._v(" "),
      _c("p", [_vm._v("浙网文（2018）8897-715号")]),
      _vm._v(" "),
      _c("p", [_vm._v("增值电信业务经营许可证：浙B2-20181288")]),
      _vm._v(" "),
      _c("p", [_vm._v("miyazhu.com版权所有")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            width: "300px",
            margin: "0 auto",
            padding: "0 0 0.1rem",
          },
        },
        [
          _c(
            "a",
            {
              staticStyle: {
                display: "inline-block",
                "text-decoration": "none",
                height: "20px",
                "line-height": "20px",
              },
              attrs: { target: "_blank", href: "https://beian.miit.gov.cn" },
            },
            [
              _c("img", {
                staticStyle: { float: "left" },
                attrs: { src: "/assets/web/assets/beian.png" },
              }),
              _c(
                "p",
                {
                  staticStyle: {
                    float: "left",
                    height: "20px",
                    "line-height": "20px",
                    margin: "0px 0px 0px 5px",
                    color: "#ccc",
                  },
                },
                [_vm._v("浙公网安备 33068102000897号")]
              ),
            ]
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "imgline" }, [
      _c("img", { attrs: { src: "/assets/web/assets/ifooter_img1.png" } }),
      _vm._v(" "),
      _c("img", { attrs: { src: "/assets/web/assets/ifooter_img2.png" } }),
      _vm._v(" "),
      _c("img", { attrs: { src: "/assets/web/assets/ifooter_img3.png" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "kftop flex-column align-center" }, [
      _c("span", { staticClass: "f18 b" }, [_vm._v("人工客服")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }